:host {
  display: block;
}

.breadcrumb {
  ol {
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

@include media-max('xl') {
  // on mobile always show the last item and hide the previous ones
  .breadcrumb-item:not(:last-child) {
    display: none;
  }
}
